<template>
  <BlockUI :message="content" v-if="visible">
    <div class="box__loader">
      <div class="loader--dot"></div>
      <div class="loader--dot"></div>
      <div class="loader--dot"></div>
    </div>
  </BlockUI>
</template>

<script>
export default {
  props: ["content", "visible"],
};
</script>



// WEBPACK FOOTER //
// src/components/shared/Loader.vue